import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
  renderDatepickerWithLabel,
  renderInputWithLabel,
  renderFileForm,
  renderSelectWithLabel,
} from "../../../components/form/FormComponent";
import {
  listActivity,
  detailActivity,
} from "../../../actions/master-data/activity_action";
import {
  getActivityPending,
  getDetailActivity,
} from "../../../reducers/master-data/activity_reducer";
import {
  uploadP2kb,
  editDetailP2kb
} from "../../../actions/p2kb/p2kb_action";
import {
  getP2kbUploadPending,
  getP2kbUpload,
  getP2kbPending,
} from "../../../reducers/p2kb/p2kb_reducer";
import DetailContentLihatBerkas from "../../../components/detail/DetailContentLihatBerkas";
import ModalDocument from "../../../components/modal/ModalDocument";
import Loading from "../../../components/global-components/LoadingComponent";
import CircularProgress from "@material-ui/core/CircularProgress";

class MengajarMahasiswaModalEdit extends Component {
  constructor() {
    super();
    this.state = {
      showDocument: false,
      berkas: null,
      berkas_disabled: false,
      isDoneUploading: true,
      filename: "",
      spek_berkas: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValues = this.handleChangeValues.bind(this);
    this.handleChangeLastActivity = this.handleChangeLastActivity.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, show } = this.props;
    if (prevProps.show !== show && show === true) {
      reset();
      if (this.props.initialValues.berkas) {
        this.setState({
          berkas: (
            <DetailContentLihatBerkas
              onClick={() =>
                this.handleOpenDocument(
                  this.props.formValue.berkas,
                  "Berkas Bukti"
                )
              }
            />
          ),
        });
      }
    }
  }

  handleOpenDocument(filename, modalTitle) {
    this.setState({
      filename: filename,
      modalTitle: modalTitle,
      showDocument: true,
    });
  }

  handleChangeLastActivity() {
    const { change } = this.props;
    change("values_id", null);
  }

  handleChangeValues(values) {
    if (values) {
      const { skp_must_be_multipied, value_multipied, value_skp } = values;

      if (skp_must_be_multipied === 0) {
        this.props.change("skp_total", value_skp);
      } else {
        this.props.change("skp_total", Math.round(value_skp * value_multipied));
      }
    }
  }

  handleUploadFile(values) {
    const formName = values.target.name;
    this.setState({
      isDoneUploading: false,
      berkas_disabled: true,
      [formName]: <Loading />,
    });

    const callback = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_data) {
        this.props.change(formName, this.props.uploadP2kb_data);
        this.setState({ berkas: <Loading done={true} /> });
        setTimeout(
          () =>
            this.setState({
              [formName]: (
                <DetailContentLihatBerkas
                  onClick={() =>
                    this.handleOpenDocument(
                      this.props.formValue.berkas,
                      "Berkas Bukti"
                    )
                  }
                />
              ),
            }),
          2000
        );
      }
    };
    const error = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_error) {
        this.props.change([formName], null);
        this.setState({
          [formName]: <Loading done={true} failed={true} />,
        });
      }
    };
    this.props.uploadP2kb(values.target.files[0], callback, error);
    this.props.change("spek_berkas", values.target.files[0]);
  }

  handleSubmit(values) {
    const { onHide, handleRefresh, handleEditSkp, editDetailP2kb } = this.props;
    const {
      id,
      status,
      activity_date,
      last_activity: { value: last_activity_skp_detail_id },
      values_id: { value: values_id },
      institution_name,
      letter_number,
      berkas,
    } = values;
    values.hasEdit = true;
    if (status) {
      const param = {
        id,
        activity_date,
        last_activity_skp_detail_id,
        values_id,
        institution_name,
        letter_number,
        attachments: [
          {
            label: "Dokumen Bukti",
            filename: berkas,
          },
        ],
      };

      const call = () => {
        onHide();
        handleRefresh();
      };
      editDetailP2kb(param, call);
    } else {
      handleEditSkp(values);
      onHide();
    }
  }

  render() {
    const {
      show,
      onHide,
      handleSubmit,
      uploadP2kb_pending,
      detailActivity_data,
      editP2kb_pending,
    } = this.props;
    const { berkas, showDocument, filename, modalTitle } = this.state;

    const {
      formValue: { last_activity },
    } = this.props;
    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    let lastActivityOptions = [];
    let valuesOptions = [];
    for (let i = currentYear; i >= 1900; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }
    if (detailActivity_data && detailActivity_data.lenght !== 0) {
      lastActivityOptions = detailActivity_data[0].childrens.map(
        ({ id, values, name }) => ({ value: id, label: name, values: values })
      );
    }
    if (last_activity) {
      let selectedOption = lastActivityOptions.find(
        (item) => item.value === last_activity.value
      );
      if (selectedOption) {
        valuesOptions = selectedOption.values.map((item) => ({
          ...item,
          value: item.id,
        }));
      }
    }
    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalDocument
          show={showDocument}
          onHide={() => this.setState({ showDocument: false })}
          filepath="member_p2kb"
          filename={filename}
          modalTitle={modalTitle}
        />

        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600 }}>Edit SKP</p>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
          >
            <Column
              vertical="center"
              horizontal="stretch"
              className={css(styles.bodyModal)}
            >
              <Field
                name="activity_date"
                placeholder="Masukkan tanggal kegiatan"
                label="Tanggal Kegiatan"
                component={renderDatepickerWithLabel}
              />
              <Field
                name="institution_name"
                placeholder="Masukkan nama institusi"
                label="Nama Institusi"
                component={renderInputWithLabel}
              />
              <Field
                name="last_activity"
                placeholder="Pilih mahasiswa bimbingan"
                label="Mahasiswa Bimbingan"
                options={lastActivityOptions}
                onChange={this.handleChangeLastActivity}
                component={renderSelectWithLabel}
              />
              <Field
                name="values_id"
                placeholder="Pilih Waktu"
                label="Waktu (Jam per Tahun)"
                options={valuesOptions}
                onChange={this.handleChangeValues}
                component={renderSelectWithLabel}
              />
              <Field
                name="letter_number"
                placeholder="Masukkan no surat penugasan"
                label="No Surat Penugasan"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="skp_total"
                placeholder="Jumlah SKP"
                label="Jumlah SKP"
                component={renderInputWithLabel}
              />
              <Field
                name="berkas"
                type="file"
                fileType="skp"
                title="Berkas Bukti"
                disabled={this.state.berkas_disabled}
                isDone={this.state.isDoneUploading}
                message={berkas ? berkas : "PDF, PNG, JPG maksimal 1 MB"}
                onChange={this.handleUploadFile}
                component={renderFileForm}
              />
            </Column>

            <Row
              horizontal="flex-end"
              vertical="center"
              className={css(styles.footerModal)}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={uploadP2kb_pending || editP2kb_pending}
                className={css(styles.approveButton)}
                startIcon={
                  uploadP2kb_pending || editP2kb_pending ? (
                    <CircularProgress size={14} color="secondary" />
                  ) : (
                    <CheckIcon />
                  )
                }
              >
                simpan
              </Button>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    backgroundColor: "#FBFBFD",
    padding: "20px 40px",
  },
  bodyModal: {
    padding: "0px 40px 20px",
    width: "100%",
  },
});

function validate(values) {
  const maxFileSize = 1000000; //1MB
  const fileType = ["application/pdf", "image/png", "image/jpg", "image/jpeg"]
  const {
    activity_date,
    institution_name,
    last_activity,
    values_id,
    letter_number,
    berkas,
    spek_berkas
  } = values;
  const errors = {};
  if (!activity_date) {
    errors.activity_date = "Tanggal kegiatan wajib diisi";
  }

  if (!institution_name) {
    errors.institution_name = "Nama institusi diisi";
  }
  if (!last_activity) {
    errors.last_activity = "Tingkat wajib diisi";
  }
  if (!values_id) {
    errors.values_id = "Waktu wajib diisi";
  }
  if (!letter_number) {
    errors.letter_number = "No surat penugasan wajib diisi";
  }
  if (!berkas) {
    errors.berkas = "Berkas berkas bukti wajib diisi";
  }
  else{
    if (spek_berkas && (spek_berkas.type !== fileType[0] && spek_berkas.type !== fileType[1] && spek_berkas.type !== fileType[2] && spek_berkas.type !== fileType[3])){
      errors.berkas = "Format file hanya bisa PDF, PNG, JPG"
    }
    else if (spek_berkas && (spek_berkas.size > maxFileSize)){
      errors.berkas = "File lebih dari 1 MB"
    }
  }
  return errors;
}

MengajarMahasiswaModalEdit = reduxForm({
  form: "MengajarMahasiswaModalEdit",
  validate: validate,
  shouldError: () => true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(MengajarMahasiswaModalEdit);

function mapStateToProps(state) {
  const {
    listActivity,
    uploadP2kb,
    detailActivity,
    selectedSKP,
    editDetailP2kb,
  } = state;
  const selector = formValueSelector("MengajarMahasiswaModalEdit");
  const formValue = selector(state, "berkas", "last_activity", "spek_berkas");
  let initialValues = {};
  if (selectedSKP) {
    initialValues = selectedSKP;
  }
  return {
    listActivity_pending: getActivityPending(listActivity),
    detailActivity_data: getDetailActivity(detailActivity),
    uploadP2kb_pending: getP2kbUploadPending(uploadP2kb),
    uploadP2kb_data: getP2kbUpload(uploadP2kb),
    editP2kb_pending: getP2kbPending(editDetailP2kb),
    formValue,
    initialValues,
  };
}

export default connect(mapStateToProps, {
  listActivity,
  detailActivity,
  uploadP2kb,
  editDetailP2kb,
})(withRouter(MengajarMahasiswaModalEdit));
